/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation SaveSimulationPricingsIndividualHealthGranteesMutation($input: SaveSimulationPricingsIndividualHealthGrantees_M_simulation_pricings_individual_healthInput!) {
    saveSimulationPricingsIndividualHealthGrantees_M_simulation_pricings_individual_health(input: $input) {
      ok
      error
      
    }
  }
`;

export default mutation;
